module.exports = {
    'defaultWebSiteTitle': 'Davi Kawasaki - Desenvolvimento Web e Soluções de Engenharia',
    'selectLanguage': 'Selecione o seu idioma',
    'dateUntilNow': 'Atualmente',
    'projectPhotosEmpty': 'Nenhuma imagem e/ou foto foi registrada ainda para esse projeto.'
};